import React from 'react';

export const Pagination = ({ metadata, onPageChange }) => {
  const { page, pages, total, has_next, has_previous } = metadata;
  if (total == 0) {
    return;
  }
  const totalPages = Math.ceil(total / metadata.per_page);
  const currentPage = page + 1;

  let pageIndexes = []
  const pageIndexList = [pageIndexes];
  let lastIndex = -1;
  [
    0,
    1,
    2,
    currentPage - 2,
    currentPage - 1,
    currentPage,
    totalPages - 3,
    totalPages - 2,
    totalPages - 1
  ].forEach(i => {
    if (i < lastIndex + 1 || i >= totalPages) {
      return
    }
    if (pageIndexes.length) {
      if (pageIndexes.includes(i)) {
        return
      }
      if (i != pageIndexes[pageIndexes.length - 1] + 1) {
        pageIndexes = []
        pageIndexList.push(pageIndexes)
      }
    }
    pageIndexes.push(i)
    lastIndex = i
  })
  return (
    <nav className="nsw-pagination" aria-label="Pagination">
      <ul>
        <li>
          <a className={"nsw-icon-button"+(has_previous ? "" : " disabled")} href="#" aria-disabled={!has_previous} onClick={e => {
            e.preventDefault()

            if (has_previous) {
              onPageChange(page - 1)
            }
          }}>
            <span className="material-icons nsw-material-icons" focusable="false" aria-hidden="true">keyboard_arrow_left</span>
            <span className="sr-only">Previous</span>
          </a>
        </li>
        {pageIndexList.map((pageIndexes, i) => (
          <React.Fragment key={`page-group-${i}`}>
            {pageIndexes.map(page => {
            
              // Preserve existing query params
              const params = new URLSearchParams(window.location.search);
              params.set("page", page);               // update only page param
              const targetUrl = `?${params.toString()}`;
              return (
                <li key={`page-${page}`}>
                  <a 
                    className={page + 1 === currentPage ? "active" : ""} 
                    // href="#" 
                    href={targetUrl}
                    onClick={e => {
                      e.preventDefault();
                      onPageChange(page);
                    }}
                  >
                    <span className="sr-only">Page</span>
                    {page + 1}
                  </a>
                </li>
              );
            })}
            {i !== pageIndexList.length - 1 && (
              <li key={`ellipsis-${i}`}>...</li>
            )}
          </React.Fragment>
        ))}
        <li>
          <a className={"nsw-icon-button"+(has_next ? "" : " disabled")} href="#" aria-disabled={!has_next} onClick={e => {
            e.preventDefault()

            if (has_next) {
              onPageChange(page + 1)
            }
          }}>
            <span className="material-icons nsw-material-icons" focusable="false" aria-hidden="true">keyboard_arrow_right</span>
            <span className="sr-only">Next</span>
          </a>
        </li>
      </ul>
    </nav>
  );
};
